import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  EventService,
  RoutingService,
  SearchboxService,
  SpellingSuggestion,
  TranslationService,
  WindowRef
} from '@spartacus/core'
import { SearchBoxComponentService, SearchBoxConfig } from '@spartacus/storefront'
import { Observable, combineLatest, of } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { ICustomSearchResults } from '../models/interface/search-results.interface'
import { AppConfigurationService } from './app-configuration.service'

const HAS_SEARCH_RESULT_CLASS = 'has-searchbox-results'

@Injectable({
  providedIn: 'root'
})
export class CustomSearchBoxComponentService extends SearchBoxComponentService {
  constructor(
    public searchService: SearchboxService,
    protected routingService: RoutingService,
    protected translationService: TranslationService,
    protected winRef: WindowRef,
    private appConfigurationService: AppConfigurationService,
    private http: HttpClient,
    protected eventService: EventService
  ) {
    super(searchService, routingService, translationService, winRef, eventService)
  }

  customGetResults(config: SearchBoxConfig): Observable<ICustomSearchResults> {
    return combineLatest([
      this.getProductResults(config),
      this.getProductSuggestions(config),
      // TODO:Spartacus - The 'getSearchMessage' method's signature changed to: 'getSearchMessage(  config: SearchBoxConfig): Observable<string | undefined>'
      this.getSearchMessage(config),
      this.getSearchSpellingSuggestion()
    ]).pipe(
      map(([productResults, suggestions, message, spellingSuggestion]) => {
        return {
          products: productResults ? productResults.products : null,
          suggestions,
          message,
          spellingSuggestion: spellingSuggestion ? spellingSuggestion : null
        }
      }),
      tap((results) => this.toggleBodyClass(HAS_SEARCH_RESULT_CLASS, this.customHasResults(results)))
    )
  }

  public customHasResults(results: ICustomSearchResults): boolean {
    return (
      (!!results.products && results.products.length > 0) ||
      !!results.spellingSuggestion ||
      (!!results.suggestions && results.suggestions.length > 0) ||
      !!results.message
    )
  }

  public getSearchSpellingSuggestion(): Observable<SpellingSuggestion> {
    let results = {} as SpellingSuggestion
    this.searchService.getResults().subscribe((value) => (results = value.spellingSuggestion))
    return of(results)
  }

  public getMaterialSearch(searchTerm, curPage) {
    const baseSiteUrl: string = this.appConfigurationService.getBaseSiteUrl()
    // const getUrl = `${baseSiteUrl}/products/search?fields=products(code%2Cname%2Csummary)%2Cpagination(DEFAULT)%2Csorts(DEFAULT)%2CfreeTextSearch%2CcurrentQuery&query=5&pageSize=100&currentPage=${curPage}&lang=en&curr=AUD`;
    const getUrl = `${baseSiteUrl}/products/search?fields=products(code,name,summary,configurable,configuratorType,price(FULL),images(DEFAULT),stock(FULL),unit(FULL),averageRating,variantOptions),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery&query=&pageSize=20&currentPage=${curPage}`

    return this.http.get<any>(getUrl)
  }
}
